import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/button";
import InputLabel, { InputLabelSelect } from "../../components/inputLabel";
import PageTitle from "../../components/pageTitle";
import registrosBiometricosActions from "../../redux/registrosBiometricos/actions";
import { StoreState } from "../../redux/reduxTypes";
import { RegistroBiometricoState, UserSession } from "../../types/state.types";
import {
  AreaCooperado,
  AreaData,
  AreaInfo,
  ColunasDescricao,
  ContainerPagina,
  FormFiltros,
  LinhasTabela,
  TabelaConteudo,
} from "./styled";
import { getSessionConfig } from "../../utils/session-helper";
import IndicadorSemDados from "../../components/indicadorSemDados";

function RegistroBiometrico() {
  const dispatch = useDispatch();
  const {
    filtros,
    filtrosBuscados,
    listaLotacoes,
    dadosRegistros,
    requisitado,
    loading,
  } = useSelector<StoreState, RegistroBiometricoState>(
    (state) => state.registrosBiometricosState
  );
  const userData = useSelector<StoreState, UserSession | undefined>(
    (state) => state.loginState.userData
  );
  const [cooperativaSessionData] = useState(getSessionConfig());

  const setFiltros = (value: {}) => {
    dispatch(
      registrosBiometricosActions.setFiltros({
        ...filtros,
        ...value,
      })
    );
  };

  const buscarLotacoes = useCallback(async () => {
    await dispatch(
      registrosBiometricosActions.buscarLotacoes(
        filtros.dataInicio,
        filtros.dataFim
      )
    );
  }, [dispatch, filtros.dataFim, filtros.dataInicio]);

  const pesquisarRegistros = useCallback(async () => {
    await dispatch(
      registrosBiometricosActions.buscar(
        filtros.dataInicio,
        filtros.dataFim,
        filtros.lotacaoId ?? "0"
      )
    );
  }, [dispatch, filtros.dataFim, filtros.dataInicio, filtros.lotacaoId]);

  useEffect(() => {
    if (!requisitado) {
      dispatch(registrosBiometricosActions.inicializaEstado());
    }
  }, [dispatch, requisitado]);

  return (
    <ContainerPagina>
      <PageTitle titulo="Registros Biométricos Sem Previsão de Produção" />

      <FormFiltros>
        <div>
          <InputLabel
            labelText="Início"
            labelId="incio"
            type="date"
            value={filtros.dataInicio}
            onChange={(value) => {
              setFiltros({
                dataInicio: value,
              });
            }}
            onBlur={() => {
              buscarLotacoes();
            }}
            required
          />

          <InputLabel
            labelText="Fim"
            labelId="fim"
            type="date"
            value={filtros.dataFim}
            onChange={(value) => {
              setFiltros({
                dataFim: value,
              });
            }}
            onBlur={() => {
              buscarLotacoes();
            }}
            required
          />

          <InputLabelSelect
            labelText="Lotação"
            labelId="lotacaoId"
            options={listaLotacoes.map((item) => {
              return { label: item.Nome, value: item.ID.toString() };
            })}
            value={filtros.lotacaoId}
            onChange={(value) => {
              setFiltros({
                lotacaoId: value,
              });
            }}
            required
          />
        </div>

        <div>
          <Button
            onClick={(event) => {
              event.preventDefault();
              pesquisarRegistros();
            }}
            primary
          >
            Consultar
          </Button>
        </div>
      </FormFiltros>

      <div className="tabela">
        {!loading && dadosRegistros && dadosRegistros.length > 0 ? (
          <TabelaConteudo>
            <tbody>
              <tr>
                <td>
                  <header>
                    <AreaData>
                      <tbody>
                        <tr>
                          <td>
                            {new Date().toLocaleDateString("pt-Br", {
                              weekday: "long",
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })}
                          </td>
                        </tr>
                      </tbody>
                    </AreaData>
                    <AreaInfo>
                      <tbody>
                        <tr>
                          <td>
                            <img
                              src={
                                "data:image/png;base64, " +
                                cooperativaSessionData.Logo
                              }
                              alt={`Logotipo - ${
                                cooperativaSessionData.Nome?.split(" ")[0]
                              }`}
                            />
                          </td>
                          <td className="containerInfos">
                            <span>
                              <strong>
                                Registros Biométricos Sem Previsão de Produção
                              </strong>
                              <br />
                              PERÍODO: &nbsp;
                              <strong>
                                {filtrosBuscados.dataInicio
                                  .split("-")
                                  .reverse()
                                  .join("/")}
                                &nbsp;à&nbsp;
                                {filtrosBuscados.dataFim
                                  .split("-")
                                  .reverse()
                                  .join("/")}
                              </strong>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </AreaInfo>
                    <AreaCooperado>
                      <tbody>
                        <tr>
                          <td>
                            Cooperado:{" "}
                            <strong>{userData ? userData.Nome : ""}</strong>
                          </td>
                          <td>
                            Matricula:{" "}
                            <strong>
                              {userData ? userData.Matricula : ""}
                            </strong>
                          </td>
                          <td>
                            Lotacao:{" "}
                            <strong>{dadosRegistros[0].SiglaLotacao}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </AreaCooperado>
                  </header>

                  <ColunasDescricao>
                    <tbody>
                      <tr>
                        <td>Matrícula</td>
                        <td>Horário Registro</td>
                        <td>Situação</td>
                      </tr>
                    </tbody>
                  </ColunasDescricao>
                  <main>
                    <LinhasTabela>
                      <tbody>
                        {dadosRegistros ? (
                          dadosRegistros.map((espelho, i) => {
                            return (
                              <tr key={i}>
                                <td>{espelho.Matricula}</td>
                                <td>{espelho.HorarioRegistro}</td>
                                <td>{espelho.Situacao}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <></>
                        )}
                      </tbody>
                    </LinhasTabela>
                  </main>
                </td>
              </tr>
            </tbody>
          </TabelaConteudo>
        ) : (
          <IndicadorSemDados />
        )}
      </div>
    </ContainerPagina>
  );
}

export default RegistroBiometrico;
